import React from "react"
import ChooseBuildPathContent from "./ChooseBuildPathContent"
import SetupNavbar from "../../components/Navbar/SetupNavbar"
import {useOrgBankingSetup} from "../../services/orgBankingSetup"
import {useAccessToken} from "../../services/auth"

export default function ChooseBuildPath() {
	const {fetch} = useOrgBankingSetup()
	const accessToken = useAccessToken()
	return (
		<>
			<SetupNavbar />
			<ChooseBuildPathContent accessToken={accessToken} fetch={fetch} />
		</>
	)
}
